import type { CollectionPresetsApi, CollectionState } from "./types";

export function findPreset(presets: CollectionPresetsApi["list"] | undefined, id: string | null) {
  if (!id) return undefined;
  return (presets ?? []).find((preset) => preset.id === id);
}

export function findActivePreset(presets: CollectionPresetsApi["list"], state: CollectionState): string | null {
  for (const preset of presets) {
    const expected = preset.state;
    if (expected.q !== undefined && expected.q !== state.q) continue;
    if (expected.sort !== undefined && stableJson(expected.sort) !== stableJson(state.sort)) continue;
    if (expected.filters !== undefined && stableJson(expected.filters) !== stableJson(state.filters)) continue;
    return preset.id;
  }
  return null;
}

function stableJson(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(stableJson).join(",")}]`;
  if (value && typeof value === "object") {
    return `{${Object.entries(value as Record<string, unknown>).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => `${JSON.stringify(key)}:${stableJson(item)}`).join(",")}}`;
  }
  return JSON.stringify(value);
}
